import { client as btClient, usBankAccount } from 'braintree-web';
import { useEffect, useState } from 'react';

const useBraintreeBackend = (apiKey: string) => {
  const [client, setClient] = useState(null);

  useEffect(() => {
    const createClient = async () => {
      const braintreeClient = await btClient.create({
        authorization: apiKey,
      });
      // @ts-ignore - braintree-web types aren't exactly accurate...
      const bankAccount = await usBankAccount.create({
        client: braintreeClient,
      });
      // @ts-ignore - braintree-web types aren't exactly accurate...
      setClient(bankAccount);
    };

    createClient();
  }, [apiKey]);

  return client;
};

export default useBraintreeBackend;
